import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IAppConfig } from 'src/app/interfaces/IAppConfig';

@Injectable({
    providedIn: 'root'
})

export class AppConfigService {
    private _appConfig: IAppConfig;

    constructor(private _http: HttpClient){}

    /**
     * Set application config from JSON file
     * @returns {Promise<void>}
     */
    setAppConfig(): Promise<void> {
        return new Promise((resolve, reject) => {
            this._http.get<IAppConfig>('assets/config/appconfig.json').toPromise().then(config => {
                this._appConfig = config;
                resolve();
            })
            .catch(error => {
                reject(error);
            });
        });
    }

    /**
     * Get application config
     */
    get config(): IAppConfig {
        return this._appConfig;
    }
}
